import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

/**
 * Returns the appropriate sort direction icon for a table column header.
 * Replaces the duplicated getMaterialSortIcon / getUserSortIcon / getSortIcon
 * implementations across material.helpers, user.helpers, and contactHelpers.
 */
export function getSortIcon(isActive: boolean, direction: 'asc' | 'desc') {
  if (!isActive) return <ArrowUpDown className="h-3 w-3" />;
  return direction === 'asc' ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />;
}
